import * as React from 'react';
import { IMarkerQuiz } from 'store/StateInterfaces';

import Form from 'react-bootstrap/Form'
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import Container from 'react-bootstrap/Container';
import Button from 'react-bootstrap/Button';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';

import { toTime } from 'Utils/common';

interface IMarkerEditProps {
    marker: IMarkerQuiz;
    cancelCallback: any;
}

interface IMarkerEditState {
    type: string;
    options: Array<string>;
}

export default class MarkerEdit extends React.Component<IMarkerEditProps, IMarkerEditState> {
    constructor(props: IMarkerEditProps) {
        super(props);
        this.state = {
            type: 'mcq',
            options: ['', '']
        }

    }

    componentDidMount() {

    }

    handleCancel = () => {
        this.props.cancelCallback();
    }

    handleSave = (event) => {
        const form = event.currentTarget;
        console.log(form);
        event.preventDefault();
        event.stopPropagation();
    }

    handleTypeChange = (type) => {
        this.setState({ type });
    }
    handleAddOption = () => {
        this.setState((state) => {
            const opt = [...state.options]
            opt.push('');
            return {
                ...state,
                options: opt
            }
        })
    }

    public render() {
        return (
            <Container style={{ background: 'white' }}>
                <div style={{ textAlign: "center" }}>
                    <h4>Edit Quiz</h4>
                </div>
                <Form onSubmit={this.handleSave}>
                    <Form.Row>
                        <Form.Group as={Col} md='4' controlId='time'>
                            <Form.Control
                                required
                                type='time'
                                disabled
                                value={`${toTime(this.props.marker.time)}`}
                            />
                        </Form.Group>
                        <Form.Group as={Col} md='8' controlId='title'>
                            <Form.Control
                                required
                                type='text'
                                defaultValue={this.props.marker.quiz_title}
                                placeholder='Quiz Title'
                            />
                        </Form.Group>
                    </Form.Row>
                    <Row>
                        <Col>
                            Question Type
              </Col>
                    </Row>
                    <br />
                    <Row>
                        <Col md={3}>
                            <input type="radio" id="mcq" defaultChecked name="qtype" onClick={(e) => this.handleTypeChange('mcq')} />
                            {' '}
                            <label htmlFor="mcq">Multiple Choice</label>
                        </Col>

                        <Col md={3}>
                            <input type="radio" id="scq" name="qtype" onClick={(e) => this.handleTypeChange('scq')} />
                            {' '}
                            <label htmlFor="scq">Single Choice</label>
                        </Col>

                        <Col md={3}>
                            <input type="radio" id="fxd" name="qtype" onClick={(e) => this.handleTypeChange('fxd')} />
                            {' '}
                            <label htmlFor='fxd'>Fixed</label>
                        </Col>

                        <Col md={3}>
                            <input type="radio" id='qg' name="qtype" onClick={(e) => this.handleTypeChange('qg')} />
                            {' '}
                            <label htmlFor="qg">Question Group</label>
                        </Col>

                    </Row>
                    <br />
                    <Form.Row>
                        <Form.Group as={Col} md='12' controlId='description'>
                            <Form.Control
                                required
                                type='text'
                                defaultValue=''
                                placeholder='Question Description'
                            />
                        </Form.Group>
                    </Form.Row>
                    <hr />
                    {
                        this.state.type === 'mcq' || this.state.type === 'scq' ?
                            (
                                // mcq or scq
                                <React.Fragment>
                                    {
                                        this.state.options.map((opt, i) => {
                                            return (
                                                <Form.Row key={i}>
                                                    <Form.Group as={Col} md='12' controlId={`option-${i}`}>
                                                        <Form.Control
                                                            required
                                                            type='text'
                                                            defaultValue={opt}
                                                            placeholder={`Option ${i}`}
                                                        />
                                                        <input id={`ans-${i}`}
                                                            style={{
                                                                position: 'absolute',
                                                                right: '50px',
                                                                top: '6px'
                                                            }}
                                                            type={this.state.type === 'mcq' ? 'checkbox' : 'radio'}
                                                            name={this.state.type}
                                                            onClick={(e) => console.log(e.target)}
                                                        />
                                                    </Form.Group>
                                                </Form.Row>
                                            )
                                        })
                                    }
                                    <Button variant='light' onClick={this.handleAddOption}>
                                        <AddCircleOutlineIcon fontSize="small" />
                                        Add Option
                                    </Button>
                                </React.Fragment>
                            )
                            :
                            this.state.type === 'fxd' ?
                                (
                                    <React.Fragment>
                                        {
                                            this.state.options.map((opt, i) => {
                                                return (
                                                    <Form.Row key={i}>
                                                        <Form.Group as={Col} md='12' controlId={`answer-${i}`}>
                                                            <Form.Control
                                                                required
                                                                type='text'
                                                                defaultValue={opt}
                                                                placeholder={`Answer ${i}`}
                                                            />
                                                        </Form.Group>
                                                    </Form.Row>
                                                )
                                            })
                                        }
                                        <Button variant='light' onClick={this.handleAddOption}>
                                            <AddCircleOutlineIcon fontSize="small" />
                                        Add Answer
                                    </Button>
                                    </React.Fragment>
                                )
                                :
                                this.state.type === 'qg' ?
                                    (
                                        null
                                    )
                                    :
                                    (
                                        null
                                    )
                    }
                    <br />
                    <br />
                    <Form.Row>
                        <Form.Group as={Col} md='12' controlId='hint'>
                            <Form.Control
                                type='text'
                                defaultValue=''
                                placeholder='Hint'
                            />
                        </Form.Group>
                    </Form.Row>

                    <Form.Row>
                        <Form.Group as={Col} md='3' controlId='marks'>
                            Marks
                <Form.Control
                                type='number'
                                defaultValue='0'
                            />
                        </Form.Group>
                        <Form.Group as={Col} md={{ span: 3, offset: 3 }} controlId='attempts'>
                            Attempts
                <Form.Control
                                type='number'
                                defaultValue='1'
                            />
                        </Form.Group>
                    </Form.Row>
                    <Row>
                        <Col md={2}>
                            <Button style={{ border: '1px solid grey', width: '100%' }} variant='light' onClick={this.handleCancel}>
                                Delete
                </Button>
                        </Col>
                        <Col md={{ span: 4, offset: 4 }}>
                            <Button style={{ border: '1px solid grey', width: '100%' }} variant='light'>
                                Advanced Settings
                </Button>
                        </Col>
                        <Col md={2}>
                            <Button style={{ width: '100%' }} type='submit'>
                                Save
                </Button>
                        </Col>
                    </Row>
                </Form>
            </Container >
        );
    }
}

